import React, { useState } from 'react';
import { List, LayoutGrid, LayoutList } from 'lucide-react';

const VIEW_MODES = [
  { key: 'stack',  label: '스택형',  Icon: LayoutGrid,  desc: '색상 바로 표시' },
  { key: 'detail', label: '상세형',  Icon: LayoutList,  desc: '일정 이름 표시' },
];

const EventEditPanel = ({
  currentTitle,
  isEditing,
  handleStartEdit,
  handleCancel,
  handleClearAll,
  handleSave,
  displayMode,
  onDisplayModeChange,
  showLegend,
}) => {
  const [showModeMenu, setShowModeMenu] = useState(false);

  return (
    <div className="schedule-page-title" style={{ position: 'relative' }}>
      <span>{currentTitle || '달력'}</span>
      <div className="top-edit-buttons" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>

        {/* 범례 - 삼선 버튼 왼쪽 */}
        {showLegend && !isEditing && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginRight: 4 }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 11, color: '#6b7280' }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#ef4444', display: 'inline-block', flexShrink: 0 }} />
              앱
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 11, color: '#6b7280' }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#3b82f6', display: 'inline-block', flexShrink: 0 }} />
              구글
            </span>
          </div>
        )}

        {/* 삼선 모드 버튼 - 편집 버튼 왼쪽 */}
        {!isEditing && onDisplayModeChange && (
          <div style={{ position: 'relative' }}>
            <button
              className="edit-button"
              onClick={() => setShowModeMenu(prev => !prev)}
              title="보기 모드"
              style={{ display: 'flex', alignItems: 'center', gap: 3 }}
            >
              <List size={15} />
            </button>
            {showModeMenu && (
              <>
                <div
                  style={{ position: 'fixed', inset: 0, zIndex: 998 }}
                  onClick={() => setShowModeMenu(false)}
                />
                <div style={{
                  position: 'absolute', top: '110%', right: 0, zIndex: 999,
                  backgroundColor: 'white', borderRadius: 12,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  border: '1px solid #e5e7eb', minWidth: 160, overflow: 'hidden',
                }}>
                  {VIEW_MODES.map(({ key, label, Icon, desc }) => (
                    <button
                      key={key}
                      onClick={() => { onDisplayModeChange(key); setShowModeMenu(false); }}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        width: '100%', padding: '11px 14px', border: 'none',
                        background: displayMode === key ? '#eff6ff' : 'white',
                        cursor: 'pointer', textAlign: 'left',
                        borderBottom: '1px solid #f3f4f6',
                      }}
                    >
                      <Icon size={16} color={displayMode === key ? '#2563eb' : '#6b7280'} />
                      <div>
                        <div style={{ fontSize: 13, fontWeight: displayMode === key ? 700 : 500, color: displayMode === key ? '#2563eb' : '#111827' }}>
                          {label}
                        </div>
                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{desc}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* 편집 버튼 */}
        {!isEditing ? (
          <button className="edit-button" onClick={handleStartEdit}>편집</button>
        ) : (
          <>
            <button className="edit-button cancel-button" onClick={handleCancel}>취소</button>
            <button className="edit-button clear-button" onClick={handleClearAll}>초기화</button>
            <button className="edit-button save-button" onClick={handleSave}>저장</button>
          </>
        )}
      </div>
    </div>
  );
};

export default EventEditPanel;
